import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-3 bg-white border border-[#d8d8e2] rounded-lg p-4 text-left",
  "data-testid": "check-validation-summary-card"
}
const _hoisted_2 = { class: "flex items-start justify-between gap-3" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-x-4 gap-y-3 text-sm" }
const _hoisted_4 = { class: "col-span-2 flex flex-col gap-0.5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", { class: "text-xs text-neutral50" }, "Unidade · Escala", -1)
const _hoisted_6 = { class: "font-bold text-textPrimary" }
const _hoisted_7 = { class: "flex flex-col gap-0.5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", { class: "text-xs text-neutral50" }, "Data do plantão", -1)
const _hoisted_9 = { class: "text-textPrimary" }
const _hoisted_10 = { class: "flex flex-col gap-0.5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", { class: "text-xs text-neutral50" }, "Previsto", -1)
const _hoisted_12 = {
  class: "text-textPrimary",
  "data-testid": "check-validation-summary-expected"
}
const _hoisted_13 = { class: "flex flex-col gap-0.5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dt", { class: "text-xs text-neutral50" }, "Digitado", -1)
const _hoisted_15 = {
  class: "font-bold text-textPrimary",
  "data-testid": "check-validation-summary-typed"
}
const _hoisted_16 = { class: "flex flex-col gap-0.5" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", { class: "text-xs text-neutral50" }, "Diferença", -1)
const _hoisted_18 = { class: "flex flex-col gap-0.5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dt", { class: "text-xs text-neutral50" }, "Lançado por", -1)
const _hoisted_20 = { class: "text-textPrimary" }
const _hoisted_21 = { class: "flex flex-col gap-0.5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("dt", { class: "text-xs text-neutral50" }, "Enviado para análise", -1)
const _hoisted_23 = { class: "text-textPrimary" }
const _hoisted_24 = {
  key: 0,
  class: "text-neutral50"
}

import { computed } from 'vue'

import DoctorInfo from '@/components/DoctorInfo.vue'
import { formatDateTimeBR } from '@/utils/date'

import CheckValidationStatusBadge from './CheckValidationStatusBadge.vue'
import {
  DISPLAY_FALLBACK,
  computeDiffMinutes,
  formatCrmLabel,
  formatDiffMinutes,
  formatHourRange
} from '../mappers'
import type { CheckValidationRow } from '../types'

interface TypedHours {
  checkin: string | null
  checkout: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckSummaryCard',
  props: {
    row: {},
    typedHours: { default: null },
    timezone: { default: '' },
    doctorNameOverride: { default: null },
    crm: { default: null }
  },
  setup(__props: any) {

const props = __props;



const doctorName = computed(() => props.doctorNameOverride ?? props.row.doctor.name)

const crmLabel = computed(
  () => props.row.doctor.crmLabel ?? formatCrmLabel(props.crm?.number, props.crm?.uf)
)

const typedRange = computed(() =>
  props.typedHours
    ? formatHourRange(props.typedHours.checkin, props.typedHours.checkout, props.timezone)
    : props.row.typedRange
)

const diffMinutes = computed(() => {
  if (!props.typedHours) return props.row.diffMinutes
  return computeDiffMinutes(
    { start: props.row.expectedStartIso, end: props.row.expectedEndIso },
    { checkin: props.typedHours.checkin, checkout: props.typedHours.checkout }
  )
})

const diffLabel = computed(() =>
  props.typedHours ? formatDiffMinutes(diffMinutes.value) : props.row.diffLabel
)

// O `EDITED_DURING_REVIEW` chega pela fila e pelo detalhe; a row já reflete.
const isEditedSinceSubmit = computed(() => props.row.isEditedSinceSubmit)

const submittedAtLabel = computed(() =>
  props.row.submittedAtIso ? formatDateTimeBR(props.row.submittedAtIso) : DISPLAY_FALLBACK
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DoctorInfo, {
        name: doctorName.value,
        subtitle: crmLabel.value ?? _unref(DISPLAY_FALLBACK),
        size: "md"
      }, null, 8, ["name", "subtitle"]),
      _createVNode(CheckValidationStatusBadge, {
        status: _ctx.row.status,
        "is-overdue": _ctx.row.isOverdue,
        "is-edited-since-submit": isEditedSinceSubmit.value
      }, null, 8, ["status", "is-overdue", "is-edited-since-submit"])
    ]),
    _createElementVNode("dl", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("dd", _hoisted_6, _toDisplayString(_ctx.row.unit) + " · " + _toDisplayString(_ctx.row.scheduleLabel), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.row.stationDate), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.row.expectedRange), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("dd", _hoisted_15, _toDisplayString(typedRange.value), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("dd", {
          class: _normalizeClass(diffMinutes.value ? 'font-bold text-textPrimary' : 'text-neutral50'),
          "data-testid": "check-validation-summary-diff"
        }, _toDisplayString(diffLabel.value), 3)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("dd", _hoisted_20, _toDisplayString(_ctx.row.createdBy?.name ?? _unref(DISPLAY_FALLBACK)), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("dd", _hoisted_23, [
          _createTextVNode(_toDisplayString(submittedAtLabel.value) + " ", 1),
          (_ctx.row.queueTimeLabel !== _unref(DISPLAY_FALLBACK))
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, " (" + _toDisplayString(_ctx.row.queueTimeLabel) + " em fila) ", 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})